import WidgetModule from "@eisinc/Overrides/Widgets/Basic/LinkList";

export * from "@eisinc/Overrides/Widgets/Basic/LinkList";

export default WidgetModule;
